export default "__VITE_ASSET__BDTadGZd__"